/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import styled from 'styled-components';
import axios from "axios";
import dot from 'dot-object';

import DynamicView from "../index";
import Loading from "../../Loading";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getMainApiUrl, getAppHeader } from "../../../services/BaseService";

const Styles = styled.div`
	width: 100%;
	.form-loader {
		position: absolute;
		right: 0;
		top: 30px;
		left: 0;
		bottom: 0;
		.loader{
			position: absolute;
		}
	}
	.ant-modal-body{
		max-height: 500px;
		width: 700px;
		overflow-y: auto;
		padding: 0px;
	}
`;

function AjaxModal({
  actions = {},
  formsValue = {},
  call = null,
  value = null,
  parent = null,
  isGroup = false,
  formsData = {},
  repeatValues = {},
  removeFromView = [],
}) {
  const endpoint = `${getMainApiUrl()}/linking/data`;
  const [config, q, v] = call.split('::');
  const [isFetching, setIsFetching] = useState(true);
  const [form, setForm] = useState({});
  const [currentData, setCurrentData] = useState({});
  const [formOptions, setFormOptions] = useState([]);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (isFetching || currentValue !== value) {
      let unmounted = false;
      let source = axios.CancelToken.source();
      const query = q ? JSON.parse(q) : {};
      query.module = 'pme';
      setCurrentValue(value);
      if (value) {
        query.parent = value;
      }
      if (formsValue && formsValue.id) {
        query.entityId = formsValue.id;
      }
      const predefinedValues = v ? JSON.parse(v) : {};
      const requestConfig = config ? JSON.parse(config) : {};
      if (requestConfig.formFields) {
        query.formFields = requestConfig.formFields;
      }
      axios.post(endpoint, {
        ...requestConfig,
        query
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      }).then(({ data }) => {
        if (!unmounted) {
          if (data) {
            if (data.config && data.config.options) {
              setFormOptions(data.config.options)
            }
            const f = {};
            Object.keys((data.form || {})).forEach(k => {
              f[k] = {};
              const fConf = (data.form || {})[k];
              Object.keys(fConf).forEach(i => {
                f[k][i] = fConf[i];
                if (removeFromView.includes(i)) {
                  f[k][i].excludeFromView = true;
                }
              })
            });
            setForm(f);
            const backData = data.data || {};
            if (Object.keys(backData).length) {
              Object.keys(predefinedValues).forEach(pv => {
                if (typeof predefinedValues[pv] === 'string' && predefinedValues[pv].split('./').length > 1) {
                  let field = predefinedValues[pv].split('./')[1];
                  if (field.split('[]').length > 1) {
                    field = field.split('[]')[1];
                    predefinedValues[pv] = dot.pick(field, repeatValues);
                  } else {
                    predefinedValues[pv] = dot.pick(field, formsValue);
                  }
                }
              })
              const formData = Object.assign(backData, predefinedValues);
              setCurrentData(formData);
              if (value) {
                if (actions && actions.setAjaxModalData) {
                  const modalData = actions.ajaxModalData || {};
                  modalData[value] = formData;
                  actions.setAjaxModalData({
                    ...modalData
                  });
                }
              }
            } else {
              setCurrentData(backData);
            }
          }
          setIsFetching(false);
        }
      }).catch((e) => {
        if (!unmounted) {
          console.log(e);
          setIsFetching(false);
        }
      });
      return () => {
        source.cancel('Cancelling in cleanup');
        unmounted = true;
      };
    }
  }, [value, isFetching])

  return <Styles>
    {
      isFetching ?
        <div className="form-loader"><Loading /></div> :
        <DynamicView excludeKeys={removeFromView} isGroupView={isGroup} showTitle={false} form={form} data={currentData} options={formOptions}></DynamicView>
    }
  </Styles>
}

const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(AjaxModal);
